module.exports = __webpack_public_path__ + "ffb9bd7684ed79d15f93fbd0b3148ce6.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-italic-webfont.svg
// module id = 351
// module chunks = 0